import routeNames from '@/router/routes'
import router from '@/router'
import { AuthRequests } from '@/services/auth.requests'
import jwt from 'jsonwebtoken'
const authService = new AuthRequests()
const state = {
  authToken: localStorage.getItem('token'),
  authCredential: localStorage.getItem('authCredential'),
}

const getters = {
  previousToken: () => localStorage.getItem('previousToken'),
  authStatus: state => state.authToken != null,
  authToken: state => state.authToken,
  authCredential: state => state.authCredential,
}

const actions = {
  signOut: ({ commit }) => {
    commit('me/resetSettings', null, { root: true })
    commit('removeTokens')
    return true
  },
  signIn: ({ commit, dispatch }, { email, password }) => {
    dispatch('signOut')
    return new Promise((resolve, reject) => {
      authService.login(email, password).then(({ token }) => {
        const { sub } = jwt.decode(token)
        commit('replaceAuthToken', token)
        commit('setCredentials', sub)
        dispatch('service/getConfiguration', { authenticated:true }, { root: true })
        dispatch('me/getBookings', null, { root: true })
        router.push({ name: routeNames.main.name })
        resolve()
      }).catch((err) => {
        reject(err)
      })
    })
  },
  sendAccessMail: ({ state }, { email, nextUrl }) => {
    return new Promise((resolve, reject) => {
      authService.sendAccessMail(email, nextUrl).then(() => {
        resolve()
      }).catch((err) => {
        reject(err)
      })
    })
  },
  revokeAuth ({ state }, { operator }) {
    return new Promise((resolve, reject) => {
      authService.revoke(operator.id).then(() => {
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  },
}

const mutations = {
  replaceAuthToken: (state, token) => {
    state.authToken = token
    localStorage.setItem('token', token)
  },
  removeTokens: (state) => {
    state.authToken = null
    state.authCredential = null
    localStorage.removeItem('authCredential')
    localStorage.removeItem('token')
  },
  setCredentials: (state, authCredential) => {
    state.authCredential = authCredential
    localStorage.setItem('authCredential', authCredential)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
